import { render, staticRenderFns } from "./EditCompanyForm.vue?vue&type=template&id=2cb8d780&"
import script from "./EditCompanyForm.vue?vue&type=script&lang=js&"
export * from "./EditCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports